var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_780)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_797_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 7H13V17H31V7ZM28 14H16V10H28V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26H24V29H32V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 32H24V35H37V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 26H35V29H48V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 20H24V23H48V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 38V3H35V17H38V0H6C2.687 0 0 2.687 0 6V42H0.101C0.035 42.323 0 42.657 0 43C0 45.762 2.239 48 5 48H38V45C36.896 45 36 44.103 36 43C36 41.896 36.896 41 38 41V38H9ZM6 3V38H5C4.288 38 3.613 38.153 3 38.422V6C3 4.346 4.346 3 6 3ZM5 45C3.897 45 3 44.103 3 43C3 41.896 3.897 41 5 41H33.422C33.153 41.613 33 42.288 33 43C33 43.712 33.153 44.387 33.422 45H5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_797_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon1);
export default __webpack_public_path__ + "static/media/m_icon1.e27a710cb404128e3fb32e7661b18110.svg";
export { ForwardRef as ReactComponent };